<!--/////////////////////////// OLD DND THEME  //////////////////////////////////////////////////////////-->
<div class="container" *ngIf="theme == 'olddragNDrop'" id="default">

  <!-- Drag n Drop theme Starts -->
  <div *ngIf="theme == 'olddragNDrop'" id="dragNDrop"
    [ngClass]="(hideSelectBtn && hideResetBtn) ? null : 'dragNDropBtmPad'" class="dragNDrop">
    <div style="position:relative;">
      <div id="div1" class="div1 afu-dragndrop-box" (drop)="drop($event)" (dragover)="allowDrop($event)">
        <p class="afu-dragndrop-text">{{replaceTexts?.dragNDropBox}}</p>
      </div>
      <!-- <span class='label label-info' id="upload-file-info{{id}}">{{allowedFiles[0]?.name}}</span> -->
    </div>
  </div>
  <!-- Drag n Drop theme Ends -->
  <label for="sel{{id}}" class="btn btn-primary btn-sm afu-select-btn"
    *ngIf="!hideSelectBtn">{{replaceTexts?.selectFileBtn}}</label>
  <input type="file" id="sel{{id}}" style="display: none" *ngIf="!hideSelectBtn" (change)="onChange($event)"
    title="Select file" name="files[]" [accept]=formatsAllowed [attr.multiple]="multiple ? '' : null" />
  <button class="btn btn-info btn-sm resetBtn afu-reset-btn" (click)="resetFileUpload()"
    *ngIf="!hideResetBtn">{{replaceTexts?.resetBtn}}</button>
  <br *ngIf="!hideSelectBtn">
  <p class="constraints-info afu-constraints-info">({{formatsAllowed}}) {{replaceTexts?.sizeLimit}}: {{(convertSize(maxSize))}}
  </p>
  <!--Allowed file list-->
  <div class="row afu-valid-file" *ngFor="let sf of allowedFiles;let i=index">
    <p class="col-xs-3 textOverflow"><span class="text-primary">{{sf.name}}</span></p>
    <p class="col-xs-3 padMarg sizeC"><strong>({{convertSize(sf.size)}})</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
    <!--  <input class="col-xs-3 progress caption"  type="text"  placeholder="Caption.."  [(ngModel)]="Caption[i]"  *ngIf="!uploadStarted"/> -->
    <div class="progress col-xs-3 padMarg afu-progress-bar" *ngIf="isAllowedFileSingle && progressBarShow && !hideProgressBar">
      <span class="progress-bar progress-bar-success" role="progressbar"
        [ngStyle]="{'width':uploadPercent+'%'}">{{uploadPercent}}%</span>
    </div>
    <a class="col-xs-1" role="button" (click)="removeFile(i,'sf')" *ngIf="!uploadStarted"><i class="fa fa-times"></i></a>
  </div>
  <!--Not Allowed file list-->
  <div class="row text-danger afu-invalid-file" *ngFor="let na of notAllowedFiles;let j=index">
    <p class="col-xs-3 textOverflow"><span>{{na['fileName']}}</span></p>
    <p class="col-xs-3 padMarg sizeC"><strong>({{na['fileSize']}})</strong></p>
    <p class="col-xs-3 ">{{na['errorMsg']}}</p>
    <a class="col-xs-1 delFileIcon" role="button" (click)="removeFile(j,'na')" *ngIf="!uploadStarted">&nbsp;<i
        class="fa fa-times"></i></a>
  </div>

  <p *ngIf="uploadMsg" class="{{uploadMsgClass}} + afu-upload-status">{{uploadMsgText}}<p>
      <div *ngIf="!isAllowedFileSingle && progressBarShow && !hideProgressBar">
        <div class="progress col-xs-4 padMarg afu-progress-bar">
          <span class="progress-bar progress-bar-success" role="progressbar"
            [ngStyle]="{'width':uploadPercent+'%'}">{{uploadPercent}}%</span>
        </div>
        <br>
        <br>
      </div>
      <button *ngIf="!hideUploadButton"  class="btn btn-success afu-upload-btn" type="button" (click)="uploadFiles()"
        [disabled]=!enableUploadBtn>{{replaceTexts?.uploadBtn}}</button>
      <br>
</div>

<!--/////////////////////////// ATTACH PIN THEME  //////////////////////////////////////////////////////////-->
<div *ngIf="theme == 'attachPin'" id="attachPin">
  <div style="position:relative;padding-left:6px">
    <a class='btn up_btn afu-attach-pin' (click)="attachpinOnclick()">
      {{replaceTexts?.attachPinBtn}}
      <i class="fa fa-paperclip" aria-hidden="true"></i>
      <!-- <p style="margin-top:10px">({{formatsAllowed}}) Size limit- {{(convertSize(maxSize))}}</p> -->
      <input type="file" id="sel{{id}}" (change)="onChange($event)" style="display: none" title="Select file"
        name="files[]" [accept]=formatsAllowed [attr.multiple]="multiple ? '' : null" />
      <br>
    </a>
    &nbsp;
    <span class='label label-info' id="upload-file-info{{id}}">{{allowedFiles[0]?.name}}</span>
  </div>
</div>

<!--///////////////////////////  DND THEME  //////////////////////////////////////////////////////////-->
<div class="upload-zone-wrap" *ngIf="(theme == 'dragNDrop')">
  <div style="flex:1;min-width:280px;">
    <div class="dropzone" id="dropzone" (drop)="drop($event)" (dragover)="allowDrop($event)">
      <div class="upload-ic">⬆</div>
      <div class="dz-title">Trascina qui il file</div>
      <div class="dz-sub" *ngIf="!hideSelectBtn" >oppure</div>
      <button  type="button" class="browse-btn" (click)="attachpinOnclick()" *ngIf="!hideSelectBtn" >{{replaceTexts?.selectFileBtn}}</button>
      <input type="file" id="sel{{id}}" style="display: none" *ngIf="!hideSelectBtn" (change)="onChange($event)"
             title="Select file" name="files[]" [accept]=formatsAllowed [attr.multiple]="multiple ? '' : null" />
      <div class="dz-constraints">{{formatsAllowed}} · max {{convertSize(maxSize)}}</div>
    </div>
    <div class="selected-file-chip show" id="fileChip" *ngFor="let sf of allowedFiles;let i=index">
      <span class="f-ic">{{ getCurrentFileExt(sf) }}</span>
      <span class="f-name">{{sf.name}}&nbsp;{{convertSize(sf.size)}}
        <div class="progress col-xs-3 padMarg afu-progress-bar" *ngIf="isAllowedFileSingle && progressBarShow && !hideProgressBar">
          <span class="progress-bar progress-bar-success" role="progressbar"
                [ngStyle]="{'width':uploadPercent+'%'}">{{uploadPercent}}%</span>
        </div>
      </span>
      <button class="f-remove" title="Rimuovi selezione" (click)="removeFile(i,'sf')" *ngIf="!uploadStarted">✕</button>
    </div>
    <div class="selected-na-file-chip show" id="fileChip" *ngFor="let na of notAllowedFiles;let j=index">
      <span class="f-ic">{{ getExt(na.fileName) }}</span>
      <span class="f-name">{{na.fileName}}&nbsp;{{na.fileSize}}</span>
      <span class="f-error">{{na.errorMsg}}</span>
      <button class="f-remove" title="Rimuovi selezione" (click)="removeFile(j,'na')" *ngIf="!uploadStarted">✕</button>
    </div>
    <div class="selected-na-file-chip show {{uploadMsgClass}}" id="fileChip" *ngIf="uploadMsg" >
      <span class="f-name">{{uploadMsgText}}</span>
    </div>
    <div *ngIf="!isAllowedFileSingle && progressBarShow && !hideProgressBar">
      <div class="progress col-xs-4 padMarg afu-progress-bar">
          <span class="progress-bar progress-bar-success" role="progressbar"
                [ngStyle]="{'width':uploadPercent+'%'}">{{uploadPercent}}%</span>
      </div>
    </div>
  </div>

  <div class="upload-side" *ngIf="hasDesc || internalUploadBtn">
    <label>Descrizione allegato</label>
    <textarea [(ngModel)]="descValue" (ngModelChange)="descValueChange.emit($event)" placeholder="inserisci qui la descrizione del file"></textarea>
    <button class="btn-carica" [disabled]="!allowedFiles?.length || notAllowedFiles?.length" (click)="upload.emit()">⬆ Carica allegato</button>
  </div>
</div>

